const generateRows = (
  teams: Team[],
  onSwitch: (team: Team, value: unknown, type: 'edit' | 'delete') => void
): TableRow[] =>
  teams.map((team) => {
    // Every team is the admin's now: branch mapping is enrichment, so nothing
    // renames or removes a team behind their back. Mapped teams stay fully
    // editable — the chip is provenance, not a lock.
    const mapped = Boolean(team.crmExternalId);
    const locked = {};

    const actionBtn: TableCellAction = {
      type: `action`,
      data: [
        {
          type: 'delete',
          ...locked,
          linkData: {
            onClick: (value) => {
              onSwitch(team, value as boolean, 'delete');
            }
          }
        },
        {
          type: 'edit',
          ...locked,
          linkData: {
            onClick: (value) => {
              onSwitch(team, value as boolean, 'edit');
            }
          }
        }
      ]
    };

    const source: TableCellChip = {
      type: `chip`,
      data: [{ text: mapped ? 'CRM branch' : 'Manual' }]
    };

    const payload: TableRow = {
      name: team.teamName ?? '',
      source,
      edit: actionBtn
    };

    return payload;
  });

export default generateRows;
